import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import { operationalFunction } from 'components/UIBuilder/SectionFunction/Common';
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  //Tab组件里, sectionComponent.child.current 是对应的渲染分选组件
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ componentDefaultValue });

  sectionComponent.child.map((child, i) => {
    if (child.current != null) {
      child.current?.setState({ searchParameter: { moduleId: parameter }, moduleId: parameter });
      child.current?.child.current?.setState({ moduleId: parameter });
      setTimeout(() => {
        child.current?.getSectionDataByDefault();
      }, config.setTimeoutMilliSecond);
    }
  })
}

// 打开 Manage Folder 弹窗（XML: <button onClick="manageApprovalAdviceNoteTemplateFolder" />）
export function manageApprovalAdviceNoteTemplateFolder({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalAdviceNoteTemplate') {
      child.current?.child.current?.setState({ manageFolderShow: true });
      setTimeout(() => {
        child.current?.child.current?.manageFolder.current?.getApprovalAdviceNoteTemplateFolderList();
      }, config.setTimeoutMilliSecond);
    }
  })
}

export function addApprovalAdviceNoteTemplate({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  // 打开新增表单时把 Folder 下拉数据塞给 CustomForm
  httpClient
    .get('Admin/ApprovalAdviceNoteTemplateFolder/GetSelectOptionList?moduleId=' + sectionComponent.state.moduleId)
    .then(({ data }) => {
      if (data.result) {
        if (data.data.length > 0) {
          sectionComponent.customForm.current?.setState({ componentDataSource: { ApprovalAdviceNoteTemplateFolderId: data.data } });
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData });
  }, config.setTimeoutMilliSecond);
}

export function addBySection({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalAdviceNoteTemplate') {
      child.current?.setState({ showModal: true, componentType: 'Create', isFormModified: false });
      setTimeout(() => {
        child.current?.customForm.current?.formRef.current?.resetFields();
      }, config.setTimeoutMilliSecond);
    }
  })
}

// 单个 Folder 折叠/展开
export function collapseFolder({ component, key } = {}) {
  let data = component.state.data.map((folder, i) => {
    if (folder.key === key) {
      if (folder.Collapsed !== true) {
        folder.Collapsed = true;
      } else {
        folder.Collapsed = false;
      }
    }
    return folder;
  });
  component.setState({ data });
}

// 收起所有 folder
export function collapseAllFolders({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.map((child, i) => {
    if (child.current != null && child.current?.child.current?.props.sectionName === 'ApprovalAdviceNoteTemplate') {
      let data = child.current?.child.current?.state.data.map((folder, i) => {
        folder.Collapsed = true;
        return folder;
      });
      child.current?.child.current?.setState({ data });
    }
  })
}
